import { ApiProperty } from "@nestjs/swagger";
export class ContainerIdRequest {
    @ApiProperty()
    containerId:number;

    /**
     * 
     * @param containerId 
     */
    constructor(containerId:number) {
        this.containerId = containerId;     
    }
    
}


export class SaleOrderIdRequestLc{
    @ApiProperty()
    saleOrderId:number;

    /**
     * 
     * @param saleOrderId 
     */
    constructor(saleOrderId:number) {
        this.saleOrderId = saleOrderId;     
    }
}

export class AuthorisedRequest{
    saleOrderId:number;
   authorisedId:number;


    /**
     * 
     * @param saleOrderId 
     */

   constructor(saleOrderId:number, authorisedId:number) {
        this.saleOrderId = saleOrderId;   
        this.authorisedId = authorisedId  
    }
}

